export default "__VITE_ASSET__fd8f9703__"